import { render, staticRenderFns } from "./LinksView.vue?vue&type=template&id=d80e5426&"
import script from "./LinksView.vue?vue&type=script&lang=js&"
export * from "./LinksView.vue?vue&type=script&lang=js&"
import style0 from "./LinksView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports